<template>
    <div class="animate-pulse">

        <div class="px-5 pt-4 mb-6">
            <div class="h-4 w-32 bg-slate-200 rounded mb-3"></div>
            <div class="flex flex-wrap gap-3">
                <template v-for="n in 4" :key="n">
                    <div class="flex items-center space-x-2">
                        <!-- Add tabindex to avoid focus trap issues -->
                        <div class="h-7 w-7 rounded-full bg-slate-300" tabindex="0"></div>
                        <div class="h-3 w-16 bg-slate-200 rounded"></div>
                    </div>
                </template>
            </div>
        </div>

        <div class="px-5 mb-6">
            <div class="h-4 w-40 bg-slate-200 rounded mb-3"></div>
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4 px-5 py-3 rounded border border-slate-200">
                <template v-for="n in 6" :key="n">
                    <div class="flex items-center space-x-2">
                        <div class="h-4 w-4 rounded bg-slate-300"></div>
                        <div class="h-3 w-20 bg-slate-200 rounded"></div>
                    </div>
                </template>
            </div>
        </div>

        <div class="px-5 mb-4">
            <div class="flex justify-end">
                <div class="inline-flex w-full lg:w-auto rounded bg-slate-200 p-1" role="group">
                    <div class="h-8 w-20 bg-slate-300 rounded mx-1"></div>
                    <div class="h-8 w-20 bg-slate-300 rounded mx-1"></div>
                    <div class="h-8 w-20 bg-slate-300 rounded mx-1"></div>
                </div>
            </div>
        </div>

        <div class="px-5">
            <div class="rounded border border-slate-200">
                <template v-for="n in 5" :key="n">
                    <div class="border-b border-slate-200 px-5 py-3 flex items-center justify-between">
                        <div>
                            <div class="h-4 w-40 bg-slate-200 rounded mb-2"></div>
                            <div class="h-3 w-20 bg-slate-200 rounded"></div>
                        </div>
                        <div class="h-8 w-16 bg-slate-300 rounded"></div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonAddToListOrCampaign',
}
</script>
